import { PropertyType } from "../../Types/propertyTypes";

export const hasLinkedService = (propertyData: PropertyType, serviceName: string, returnService: boolean = false) => {
    if (propertyData && propertyData.linkedServices && propertyData.linkedServices.length > 0) {
        const linkedService = propertyData.linkedServices.find((service) => {
            return service.linkedService === serviceName
        })
        if (returnService) {
            return linkedService || null
        }
        return !!linkedService
    }
    return false
}